import {GitCommitSearchResults} from "VersionControl/Scripts/TFS.VersionControl.WebApi";

export interface GitQueryCommitsResults  extends GitCommitSearchResults {
}